import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetAllCpfDto } from 'src/app/domain/models/dto/get-all-cpf.dto';
import { IndividualAccountDto } from 'src/app/domain/models/dto/individual-account.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IndividualAccountService {
  constructor(private readonly http: HttpClient) {}

  get(individualId: number) {
    return this.http.get<ResponseObjectModel<IndividualAccountDto>>(
      `${environment.API_BASE_URL}/v1/individual-accounts/${individualId}`
    );
  }

  getAllCpf(): Observable<ResponseObjectModel<GetAllCpfDto[]>> {
    const url = `${environment.API_BASE_URL}/v1/individual-accounts/admin/getall-cpf`;
    return this.http.get<ResponseObjectModel<GetAllCpfDto[]>>(url);
  }

  putRegister(
    individualAccountDto: IndividualAccountDto,
    IndividualAccountId: number
  ) {
    return this.http.put<ResponseObjectModel<IndividualAccountDto>>(
      `${environment.API_BASE_URL}/v1/individual-accounts/${IndividualAccountId}`,
      individualAccountDto
    );
  }

  public uploadIndividualDocument(individualAccountId: number, file: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.put<any>(
      `${environment.API_BASE_URL}/v1/individual-accounts/${individualAccountId}/document`,
      formData
    );
  }

  public validateIndividualDocument(individualDocument: string, file: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('document', individualDocument);

    return this.http.post<any>(
      `${environment.API_BASE_URL}/v1/seeaway/validate-document-pf`,
      formData
    );
  }

  putComplementary(
    individualAccountDto: IndividualAccountDto,
    IndividualAccountId: number
  ) {
    return this.http.put<ResponseObjectModel<IndividualAccountDto>>(
      `${environment.API_BASE_URL}/v1/individual-accounts/complementary/${IndividualAccountId}`,
      individualAccountDto
    );
  }
}
